import React from "react"
import Grid from "../shared/grid"
import {} from "../homepage/hero.style"

import {
  StatListContainer,
  StatListItem,
  StatListNumber,
  StatListSmall,
  OverlayStyle,
} from "../shared/stats.style"

export default function HeroStatistics() {
  return (
    <Grid overlayStyle={OverlayStyle}>
      <StatListContainer>
        <StatListItem>
          <StatListNumber>2,435</StatListNumber>
          Directory Screens
        </StatListItem>
        <StatListItem>
          <StatListNumber>
            22<StatListSmall>M</StatListSmall>
          </StatListNumber>
          Avg. Annual Sesssions
        </StatListItem>
        <StatListItem>
          <StatListNumber>253</StatListNumber>
          Properties Globally
        </StatListItem>
      </StatListContainer>
    </Grid>
  )
}
